<template>
  <div class="container">
    <div class="row justify-content-center mt-5 mb-1">
      <div class="col-sm-12 col-md-8 col-lg-5 my-4">
        <div class="mb-3">
          <slot name="logo" />
        </div>

        <div class="card shadow-sm">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jQuery from "jquery";

export default {
    mounted() {
    }
}
</script>
